const noEmojisRegex = /[\uD83C-\uDBFF\uDC00-\uDFFF]+/g;

export const noEmojisValue = (value) => {
    if (!value) return;
    if (hasEmojis(value)) return;
    const noEmojis = value.replace(noEmojisRegex, "");
    return noEmojis;
}

export const hasEmojis = (value) => {
    if (!value) return;
    return noEmojisRegex.test(value);
}